import { ChartType } from "@/services/cloudchipr.api";
import { HighchartsChartType } from "@/storybook/c8r-highcharts/common/components/HighchartsChartTypeSelect";

export const chartTypeToHighchartsChartType = (
  chartType: ChartType,
): HighchartsChartType => {
  if (
    chartType === "numeral" ||
    chartType === "table" ||
    chartType === "stack"
  ) {
    return "stacked_column";
  }

  if (chartType === "bar") {
    return "column";
  }

  return chartType;
};
